import { NormalText } from '../../shared/styles'
import { WalletStyled } from './styles'
import { formatLargeText } from '../../shared/utils'
import { Box } from '@mui/material'
import { Announcement } from '../../shared/announcement/announcement'
import { CopyButton } from '../../shared/copy-button/copy-button'
import { Coins } from './coins'
import { DividerStyled } from '../../shared/divider/divider'

export const Wallet = ({ polygonAddress, tronAddress }) => {
  return (
    <WalletStyled>
      <Box display="flex" flexDirection="column" gap={'8px'} mb={'24px'}>
        {polygonAddress && (
          <>
            <NormalText>Polygon address</NormalText>
            <Box display="flex" alignItems="center" gap={'8px'}>
              <NormalText size={14} color="#0F110C" isBold>
                {formatLargeText(polygonAddress)}
              </NormalText>
              <CopyButton
                tooltipText="Copy"
                textToCopy={polygonAddress}
                iconColor="#0F110C"
                iconSize={14}
              />
            </Box>
            <Coins network="polygon" />
          </>
        )}
        <DividerStyled sx={{ my: '8px' }} />
        {tronAddress && (
          <>
            <NormalText>Tron address</NormalText>
            <Box display="flex" alignItems="center" gap={'8px'}>
              <NormalText size={14} color="#0F110C" isBold>
                {formatLargeText(tronAddress)}
              </NormalText>
              <CopyButton
                tooltipText="Copy"
                textToCopy={tronAddress}
                iconColor="#0F110C"
                iconSize={14}
              />
            </Box>
            <Coins network="tron" />
          </>
        )}
        {!polygonAddress && !tronAddress && (
          <NormalText>No wallets found, please contact support</NormalText>
        )}
      </Box>
      <Announcement
        title="Deposit wallet"
        description={
          'These are your personal wallet addresses for receiving crypto. Each network has its own dedicated address.'
        }
        withInfoIcon
      />
    </WalletStyled>
  )
}
